import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X, Lock } from 'lucide-react';

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <>
      <header className="fixed top-0 left-0 right-0 z-50 glass-effect border-b border-white/10">
        <div className="max-w-[1400px] mx-auto flex justify-between items-center px-8 py-6">
          <Link to="/" className="group">
            <h1 className="text-transparent bg-clip-text bg-gradient-to-r from-purple-400 via-pink-400 to-purple-600 font-['Poppins'] text-lg md:text-2xl font-bold tracking-tight transition-all duration-300 group-hover:scale-105">
              CHARLES KILVINGTON
            </h1>
            <p className="text-gray-400 text-[9.6px] md:text-[12.8px] tracking-tight mt-1 font-light">
              ANIMATOR · ARTIST · CREATIVE DIRECTOR
            </p>
          </Link>
          
          <div className="flex items-center gap-4">
            <Link
              to="/admin/login"
              className="flex items-center gap-2 bg-gradient-to-r from-purple-500 to-pink-500 text-white px-4 py-2 rounded-lg hover:from-purple-600 hover:to-pink-600 transition-all duration-300 text-sm font-medium shadow-lg shadow-purple-500/30"
              title="Admin Login"
            >
              <Lock size={16} />
              <span className="hidden sm:inline">ADMIN</span>
            </Link>
            
            <button 
              onClick={() => setMenuOpen(!menuOpen)}
              className="text-white hover:text-purple-400 transition-colors p-2 rounded-lg hover:bg-white/5"
              aria-label="Toggle menu"
            >
              {menuOpen ? <X size={28} /> : <Menu size={28} />}
            </button>
          </div>
        </div>
      </header>

      {/* Mobile Menu */}
      <div 
        className={`fixed inset-0 z-40 transition-all duration-300 ease-in-out ${
          menuOpen ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'
        }`}
      >
        <div 
          className="absolute inset-0 bg-black/80 backdrop-blur-xl"
          onClick={() => setMenuOpen(false)}
        />
        <div className="relative flex flex-col items-center justify-center h-full space-y-8">
          <Link 
            to="/" 
            onClick={() => setMenuOpen(false)}
            className="text-white text-5xl font-['Poppins'] font-bold hover:text-transparent hover:bg-clip-text hover:bg-gradient-to-r hover:from-purple-400 hover:to-pink-400 transition-all duration-300 transform hover:scale-110"
          >
            WORK
          </Link>
          <Link 
            to="/about" 
            onClick={() => setMenuOpen(false)}
            className="text-white text-5xl font-['Poppins'] font-bold hover:text-transparent hover:bg-clip-text hover:bg-gradient-to-r hover:from-purple-400 hover:to-pink-400 transition-all duration-300 transform hover:scale-110"
          >
            ABOUT
          </Link>
          <Link 
            to="/contact" 
            onClick={() => setMenuOpen(false)}
            className="text-white text-5xl font-['Poppins'] font-bold hover:text-transparent hover:bg-clip-text hover:bg-gradient-to-r hover:from-purple-400 hover:to-pink-400 transition-all duration-300 transform hover:scale-110"
          >
            CONTACT
          </Link>
        </div>
      </div>
    </>
  );
};

export default Header;